import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Area } from "../../../types/types";

type QueryVariables = {
  slug: string
}

export type QueryResult = {
  area: Area
}

export class AreaShowQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query Area($slug:String!) {
      area: areaBySlug(slug:$slug) {
        name
        gitesCount
        bedAndBreakfastsCount
        giteOverviewPath
        bnbOverviewPath
        bodyTitle
        bodyContent
        facet
        slug
        listTitle
        slugsForBooleanSearch
        linkListItems {
          title
          url
        }
        bodyImage {
          url(crop:"original")
          exists
        }
        departments {
          nodes {
            id
            name
            path
          }
        }
        rentalAdverts(first:3) {
          nodes {
            id
            objectName
            path
            city {
              name
            }
            bedrooms
            bathrooms
            isStudio
            priceForOverview
            maxPersons
            overviewImage {
              url(crop: "index_thumb")
            }
            lastMinuteOffers(onlySoon: true) {
              nodes {
                id
              }
            }
            displayGuestbookEntries(onlyRateable:true) {
              nodes {
                rating
              }
            }
          }
        }
        headerImage{
          url(crop:"header")
        }
      }
    }
  `
}


export const variables = (slug: string) : QueryVariables => {
  return {
    slug: slug
  }
}
